import { render, staticRenderFns } from "./PrimaryCategories.vue?vue&type=template&id=06d4e1f6"
import script from "./PrimaryCategories.vue?vue&type=script&lang=js"
export * from "./PrimaryCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports